import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Charts.module.scss';

const ChartsPie = React.memo(
  ({ element, layout, size, maxvalue, value, label, unit, alertLevel, valid }) => {
    const Gauge = () => {
      const GaugeMarkup1 =
        '<svg viewBox="0 0 114 114"> <g transform="translate(7,12)"> <rect class="gauge_bg" style="fill:#FFFFFF;stroke-width:0.3;stroke:#000000;stroke-opacity:0;" id="rect3680" width="114" height="114" x="-7" y="-12"/> <text class="gauge_label" x="42%" y="33%" dominant-baseline="middle" text-anchor="middle" style="font-family:Arial; font-size:9px; fill:black;">Nhà máy 1</text> <text class="gauge_number" x="42%" y="50%" dominant-baseline="middle" text-anchor="middle" style="font-family:Arial; font-size:24px; fill:black;">3000</text> <text class="gauge_unit" x="42%" y="65%" dominant-baseline="middle" text-anchor="middle" style="font-family:Arial; font-size:12px; fill:black;">kWh</text> <g class="gauge_range" style="fill:none;stroke:#AA00ff;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"> <g inkscape:connector-curvature="0"> <path class="gauge_show1" style="stroke-width:0.5px" d="M 0,50 4,50" transform="rotate(-25,50, 50)" />  <path class="gauge_show2" style="stroke-width:0.5px" d="M 0,50 4,50" transform="rotate(0, 50, 50)" />  <path class="gauge_show3" style="stroke-width:0.5px" d="M 96,50 100,50" transform="rotate(0,50,50)" />  <path class="gauge_show4" style="stroke-width:0.5px" d="M 96,50 100,50" transform="rotate(25,50, 50)" />  </g> <g style="stroke-width:0.3px;" inkscape:connector-curvature="0"> <path d="M 99,50 100,50" transform="rotate(5,50,50)" />  <path d="M 99,50 100,50" transform="rotate(10,50,50)" />  <path d="M 99,50 100,50" transform="rotate(15,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(20,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(30,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(35,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(40,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(45,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-5,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-10,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-15,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-20,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-25,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-30,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-35,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-40,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-45,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-50,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-55,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-60,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-65,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-70,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-75,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-80,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-85,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-90,50, 50)" />   <path d="M 0,50 1,50" transform="rotate(-5,50,50)" />  <path d="M 0,50 1,50" transform="rotate(-10,50,50)" />  <path d="M 0,50 1,50" transform="rotate(-15,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(-20,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(-30,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(-35,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(-40,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(-45,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(5,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(10,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(15,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(20,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(25,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(30,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(35,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(40,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(45,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(50,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(55,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(60,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(65,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(70,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(75,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(80,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(85,50, 50)" />  </g> </g> <path class="gauge_base" style="fill:none;stroke-width:4.2px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M 16, 84 a 48, 48,0, 1, 1, 68, 0" stroke="#ff554e" stroke-dasharray="99 300"/> <path class="gauge_hide1" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M -1,50 5,50" transform="rotate(-25,50, 50)" />  <path class="gauge_hide2" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M -1,50 5,50" transform="rotate(0, 50, 50)" />  <path class="gauge_hide3" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M 95,50 101,50" transform="rotate(0,50,50)" />  <path class="gauge_hide4" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M 95,50 100,50" transform="rotate(25,50, 50)" />  <path style="fill:none;stroke:#ff554e;stroke-width:0.8px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"   d="M 19,81 14.6,85.4" class="gauge_needle" inkscape:connector-curvature="0" transform="rotate(0,50,50)" /> </g> </svg>';
      const GaugeMarkup2 =
        '<svg viewBox="0 0 114 64"> <g transform="translate(7,12)"> <rect class="gauge_bg" style="fill:#FFFFFF;stroke-width:0.3;stroke:#000000;stroke-opacity:0;" id="rect3680" width="114" height="114" x="-7" y="-12"/> <text class="gauge_label" x="44%" y="40%" dominant-baseline="middle" text-anchor="middle" style="font-family:Arial; font-size:9px; fill:black;">Nhà máy 1</text> <text class="gauge_number" x="60%" y="68%" dominant-baseline="middle" text-anchor="end" style="font-family:Arial; font-size:24px; fill:black;">3000</text> <text class="gauge_unit" x="60%" y="68%" dominant-baseline="middle" text-anchor="start" style="font-family:Arial; font-size:12px; fill:black;">kWh</text> <g class="gauge_range" style="fill:none;stroke:#AA00ff;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"> <g inkscape:connector-curvature="0"> <path class="gauge_show1" style="stroke-width:0.5px" d="M 0,50 4,50" transform="rotate(20,50, 50)" />  <path class="gauge_show2" style="stroke-width:0.5px" d="M 0,50 4,50" transform="rotate(45, 50, 50)" />  <path class="gauge_show3" style="stroke-width:0.5px" d="M 96,50 100,50" transform="rotate(-45,50,50)" />  <path class="gauge_show4" style="stroke-width:0.5px" d="M 96,50 100,50" transform="rotate(-20,50, 50)" />  </g> <g style="stroke-width:0.3px;" inkscape:connector-curvature="0"> <path d="M 99,50 100,50" transform="rotate(0,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-5,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-10,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-15,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-20,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-25,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-30,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-35,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-40,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-45,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-50,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-55,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-60,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-65,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-70,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-75,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-80,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-85,50, 50)" />  <path d="M 99,50 100,50" transform="rotate(-90,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(0,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(5,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(10,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(15,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(20,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(25,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(30,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(35,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(40,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(45,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(50,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(55,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(60,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(65,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(70,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(75,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(80,50, 50)" />  <path d="M 0,50 1,50" transform="rotate(85,50, 50)" />  </g> </g> <path class="gauge_base" style="fill:none;stroke-width:4.2px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M 2, 50 a 48, 48,0, 1, 1, 96, 0" stroke="#ff554e" stroke-dasharray="30 300"/> <path class="gauge_hide1" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M -1,50 5,50" transform="rotate(20,50, 50)" />  <path class="gauge_hide2" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M -1,50 5,50" transform="rotate(45, 50, 50)" />  <path class="gauge_hide3" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M 95,50 101,50" transform="rotate(-45,50,50)" />  <path class="gauge_hide4" style="fill:none;stroke:#FFFFFF;stroke-width:0.6px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" inkscape:connector-curvature="0" d="M 95,50 100,50" transform="rotate(-20,50, 50)" />  <path style="fill:none;stroke:#ff554e;stroke-width:0.8px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"   d="M 0,50 6,50" class="gauge_needle" inkscape:connector-curvature="0" transform="rotate(0,50,50)" /> </g> </svg>';
      const self = {};
      self.layout = layout;
      self.bar_rotate = 0;
      self.element = document.querySelector(`#${element}`);
      if (self.layout === 1) {
        self.element.innerHTML = GaugeMarkup1;
        self.element.firstChild.setAttribute('height', size);
        self.element.firstChild.setAttribute('width', size);
        self.bar_rotate = 270;
      } else {
        self.element.innerHTML = GaugeMarkup2;
        self.element.firstChild.setAttribute('height', size / 2 + 7);
        self.element.firstChild.setAttribute('width', size);
        self.bar_rotate = 180;
      }

      self.value = 0;
      self.maxvalue = maxvalue > 0 ? maxvalue : 1;
      self.rotation = 0;
      self.color_range = '#FFFFFF';

      self.setValues = (first) => {
        self.value = first;
        self.rotation = (first / self.maxvalue) * self.bar_rotate;
        if (self.rotation > self.bar_rotate - 19) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);

          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width: 0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width: 0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width: 0px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width: 0px;');
        } else if (self.rotation > self.bar_rotate - 44) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width: 0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width: 0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else if (self.rotation > 46) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else if (self.rotation > 21) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        }
        self.element
          .getElementsByClassName('gauge_needle')[0]
          .setAttribute('transform', `rotate(${self.rotation},50,50)`);
        const totallength = self.element.getElementsByClassName('gauge_base')[0].getTotalLength();
        const newSDA = (first * totallength) / self.maxvalue;
        const gap = totallength - newSDA;
        self.element
          .getElementsByClassName('gauge_base')[0]
          .setAttributeNS(null, 'stroke-dasharray', `${newSDA} ${gap}`);

        self.element.getElementsByClassName('gauge_number')[0].innerHTML = valid ? first : '-';
      };
      self.animationDelay = 250;
      self.animateRandom = (delay) => {
        if (delay != null) self.animationDelay = delay;

        const up = Math.random() > 0.5;
        const step = Math.random() * 100;
        if (up) {
          self.value += step;
        } else {
          self.value -= step;
        }
        if (self.value < 0) self.value = 50;
        self.value %= self.maxvalue;
        self.setValues(parseInt(self.value, 10));

        setTimeout(self.animateRandom, self.animationDelay);
      };
      self.setLabel = (text) => {
        self.element.getElementsByClassName('gauge_label')[0].innerHTML = text;
      };
      self.setUnit = (text) => {
        self.element.getElementsByClassName('gauge_unit')[0].innerHTML = text;
      };
      self.setColor = (needle, range, fill, text) => {
        self.color_range = fill;
        self.element
          .getElementsByClassName('gauge_needle')[0]
          .setAttribute('style', `stroke:${needle};`);
        self.element
          .getElementsByClassName('gauge_base')[0]
          .setAttributeNS(null, 'stroke', `${needle}`);
        self.element.getElementsByClassName('gauge_bg')[0].setAttribute('style', `fill:${fill};`);
        self.element
          .getElementsByClassName('gauge_range')[0]
          .setAttribute('style', `stroke:${range};`);
        self.element
          .getElementsByClassName('gauge_number')[0]
          .setAttribute('style', `font-family:Arial; font-size:24px;fill:${text};`);
        self.element
          .getElementsByClassName('gauge_label')[0]
          .setAttribute('style', `font-family:Arial; font-size:9px;fill:${text};`);
        self.element
          .getElementsByClassName('gauge_unit')[0]
          .setAttribute('style', `font-family:Arial; font-size:12px;fill:${text};`);
        if (self.rotation > self.bar_rotate - 19) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);

          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0px;');
        } else if (self.rotation > self.bar_rotate - 44) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else if (self.rotation > 46) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else if (self.rotation > 21) {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0.6px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        } else {
          self.element
            .getElementsByClassName('gauge_hide4')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide3')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide2')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_hide1')[0]
            .setAttribute('style', `fill:none;stroke:${self.color_range};stroke-width:0px;`);
          self.element
            .getElementsByClassName('gauge_show1')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show2')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show3')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
          self.element
            .getElementsByClassName('gauge_show4')[0]
            .setAttribute('style', 'stroke-width:0.6px;');
        }
      };
      return self;
    };

    useEffect(() => {
      const GaugePie = Gauge();
      GaugePie.setValues(value);
      GaugePie.setLabel(label);
      GaugePie.setUnit(unit);
      if (alertLevel === 0) {
        GaugePie.setColor('#00C58E', '#2F495E', '#FFFFFF', '#2F495E');
      } else if (alertLevel === 1 || alertLevel === -1) {
        GaugePie.setColor('#FACC15', '#2F495E', '#FFFFFF', '#2F495E');
      } else if (alertLevel === 2 || alertLevel === -2) {
        GaugePie.setColor('#DC2626', '#2F495E', '#FFFFFF', '#2F495E');
      }
    });

    return (
      <div className={styles.chart_pie_wrapper}>
        {alertLevel === 1 ? <div className={styles.alert_icon} /> : ''}
        {alertLevel === 2 ? '' : ''}
        <div id={element} />
      </div>
    );
  },
);

ChartsPie.defaultProps = {
  alertLevel: 0,
};

ChartsPie.propTypes = {
  element: PropTypes.string.isRequired,
  layout: PropTypes.number.isRequired,
  size: PropTypes.string.isRequired,
  maxvalue: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  alertLevel: PropTypes.number,
  valid: PropTypes.bool.isRequired,
};

export default ChartsPie;
